import renderDate from '../../../../../helpers/tables/render-date'
import Receipt from '../../../../../types/api/receipt'
import Shipment from '../../../../../types/api/shipment'
import StampOrder from '../../../../../types/api/stamp-order'
import FormOrder from '../../../../../types/api/form-order'
import { AvailabilityDisplay } from './types'

export function getAvailabilityFromOrder(
    lastOrder: StampOrder | FormOrder | undefined,
    labels: { missing: string; notOrderedInfo: string }
): AvailabilityDisplay {
    if (!lastOrder) {
        return { problem: labels.missing }
    }

    if (lastOrder.orderStatus === 'Завершен') {
        return { inStock: true }
    }

    if (lastOrder.orderStatus === 'Создан') {
        return { waiting: labels.notOrderedInfo + ` №${lastOrder.id}` }
    }

    if (lastOrder.orderStatus === 'Отменен') {
        return { problem: 'Отменен' }
    }

    if (lastOrder.estimatedDate) {
        return { waiting: `Ожидается ${renderDate(lastOrder.estimatedDate)}` }
    }

    return { problem: 'Что-то пошло не так' }
}

export function getDisplayFromReceipt(receipt: Receipt | undefined): AvailabilityDisplay {
    if (!receipt) {
        return { problem: 'Что-то пошло не так' }
    }

    if (receipt.receiptStatus === 'Завершен') {
        return { inStock: true }
    }

    if (receipt.receiptStatus === 'Отменен') {
        return { problem: 'Отменен' }
    }

    if (receipt.estimatedDate) {
        return { waiting: `Ожидается ${renderDate(receipt.estimatedDate)} (№${receipt.id})` }
    }

    return { problem: 'Что-то пошло не так' }
}

export function pickWorstStatus(statuses: AvailabilityDisplay[]): AvailabilityDisplay {
    const withProblem = statuses.find(status => status.problem)
    if (withProblem) return withProblem

    const withWaiting = statuses.find(status => status.waiting)
    if (withWaiting) return withWaiting

    return { inStock: true }
}

export function matchesShipmentRelation(
    related: Shipment | undefined,
    shipment: Shipment
): boolean {
    if (!related) return false

    if (shipment.documentId && related.documentId) {
        return related.documentId === shipment.documentId
    }

    if (shipment.id != null && related.id != null) {
        return String(related.id) === String(shipment.id)
    }

    return false
}
